import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
    Button,
    Box,
    Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { SelectRowFromTable } from '../universal/Axios';
import { GenAlgIndividualTable } from './GenAlgIndividualTable';

const EditGenAlgIndividual = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [parentURL, setParentURL] = useState("")
    const [genAlgIndividualObject, setGenAlgIndividualObject] = useState([])

    let ParentLink = () =>
        <Button
            sx={{ marginLeft: '20px', textTransform: 'none', width: "140px" }}
            variant="contained"
            href={parentURL}
        >
            GO TO PARENT
        </Button>


    useEffect(() => {
        if (genAlgIndividualObject !== undefined) {
            if (genAlgIndividualObject.parent_id !== null) {
                setParentURL("edit-gen-alg-individual?id=" + genAlgIndividualObject.parent_id)
            } else {
                setParentURL("edit-gen-alg-generation?id=" + genAlgIndividualObject.gen_alg_generation_id)
            }
        } else {
        }
    }, [genAlgIndividualObject]);

    useEffect(() => {
        SelectRowFromTable("select * from gen_alg_individual where id = '" + id + "';", setGenAlgIndividualObject)
    }, [id]);


    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="h6">Gen Alg Individual: <b>{id}</b></Typography>
                </Box>
            </Box>
            <Box sx={{ float: "right", marginTop: "15px" }}>
                <ParentLink />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center", margin: '20px', fontSize: '20px' }}>
                <b>Children:</b>
            </Box>
            <div style={{ height: 400, width: '100%' }}>
                <GenAlgIndividualTable parent_id={id} />
            </div>
            <Box sx={{ marginTop: '20px', marginLeft: '10px', fontSize: '20px', height: '50px' }}>
                <Box sx={{ textAlign: "left", margin: "auto", display: "inline-block", fontSize: '20px' }}>
                    <span sx={{ float: "left" }}><b>Info:</b></span>
                </Box>
            </Box>  
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{<b>Property</b>}</TableCell>
                            <TableCell>{<b>Value</b>}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Generation</TableCell>
                            <TableCell>{<a
                                href={'edit-gen-alg-generation?id=' + genAlgIndividualObject.gen_alg_generation_id}
                            >{genAlgIndividualObject.gen_alg_generation_id}</a>}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Parent</TableCell>
                            <TableCell><a
                                href={'edit-gen-alg-individual?id=' + genAlgIndividualObject.parent_id}
                            >{genAlgIndividualObject.parent_id}</a></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Density Network Config</TableCell>
                            <TableCell>{<a
                                href={'edit-density-network-config?id=' + genAlgIndividualObject.density_network_config_id}
                            >
                                {genAlgIndividualObject.density_network_config_id}
                            </a>}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Created Date</TableCell>
                            <TableCell>
                                {genAlgIndividualObject.created_date}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default EditGenAlgIndividual